Object.assign(exports, require('./propose-change'))
Object.assign(exports, require('./save-bulk-locations'))
Object.assign(exports, require('./import-locations'))
Object.assign(exports, require('./update-location'))
